if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    static get observedAttributes() {
      return ['data-free-shipping', 'data-cart-total-amount'];
    }

    attributeChangedCallback(name, previous, next) {
      if (previous !== next) this.init();
    }

    init() {
      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const threshold = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const freeShippingRemaining = cartTotal - threshold;
      if (!Number.isFinite(threshold) || !Number.isFinite(cartTotal) || threshold < 0) {
        this.innerHTML = '';
        return;
      }
      const shippingSuccess = freeShippingRemaining >= 0;
      const progress = threshold > 0 ? Math.max(0, Math.min(100, cartTotal / threshold * 100)) : 100;
      const amount = this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format);
      const thresholdLabel = this._formatMoney(threshold, KROWN.settings.shop_money_format);
      const shippingMessage = shippingSuccess
        ? 'Versand kostenlos'
        : 'Noch <strong class="zlg-shipping-amount">' + amount + '</strong> bis versandfrei';
      const icon = shippingSuccess
        ? '<path d="m5 12 4 4L19 6"/>'
        : '<path d="M3 5h11v12H3zM14 9h4l3 4v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>';
      this.innerHTML = `
        <style>
          shipping-notice .zlg-shipping-card{--ship-accent:#d11f2a;--ship-soft:#fce9e7;box-sizing:border-box;padding:17px 18px 14px;border:1px solid #ecdcd3;border-radius:15px;background:linear-gradient(125deg,#fffaf4,#fff);text-align:left;color:#261f1b;font-family:Inter,'Trebuchet MS',sans-serif;margin:10px 0 17px;box-shadow:0 3px 13px #42251406}
          shipping-notice .zlg-shipping-card.is-complete{--ship-accent:#1c8045;--ship-soft:#e5f3e9;border-color:#cde6d4;background:linear-gradient(125deg,#f1faf3,#fff)}
          shipping-notice .zlg-shipping-top{display:flex;gap:12px;align-items:center}
          shipping-notice .zlg-shipping-icon{display:grid;place-items:center;flex:0 0 40px;width:40px;height:40px;border-radius:12px;background:var(--ship-soft);color:var(--ship-accent)}
          shipping-notice .zlg-shipping-icon svg{width:23px!important;height:23px!important;display:block;fill:none!important;stroke:currentColor!important;stroke-width:1.7}
          shipping-notice .zlg-shipping-icon svg *{fill:none!important;stroke:currentColor!important;stroke-linecap:round;stroke-linejoin:round}
          shipping-notice .zlg-shipping-copy{min-width:0;flex:1}
          shipping-notice .zlg-shipping-title{display:block;font-size:13px;font-weight:800;line-height:1.35;margin:0 0 4px;color:#261f1b;letter-spacing:0}
          shipping-notice .zlg-shipping-message{font-size:12px;line-height:1.55;color:#706054}
          shipping-notice .zlg-shipping-amount{color:var(--ship-accent);font-weight:800;white-space:nowrap;font-size:14px}
          shipping-notice .zlg-shipping-card.is-complete .zlg-shipping-title{color:var(--ship-accent)}
          shipping-notice .zlg-shipping-track{height:7px;overflow:hidden;border-radius:99px;background:#eee6de;margin:15px 0 7px}
          shipping-notice .zlg-shipping-fill{display:block;width:var(--ship-progress);height:100%;border-radius:inherit;background:linear-gradient(90deg,#ec6870,var(--ship-accent));animation:zlg-shipping-fill-in .6s cubic-bezier(.2,.8,.2,1) both;transform-origin:left center}
          shipping-notice .is-complete .zlg-shipping-fill{background:linear-gradient(90deg,#6dbd88,var(--ship-accent))}
          shipping-notice .zlg-shipping-caption{display:flex;justify-content:space-between;align-items:center;gap:12px;color:#857467;font-size:10px;line-height:1.45}
          shipping-notice .zlg-shipping-caption span:last-child{text-align:right}
          @keyframes zlg-shipping-fill-in{from{transform:scaleX(.6);opacity:.5}to{transform:scaleX(1);opacity:1}}
          @media(max-width:480px){shipping-notice .zlg-shipping-card{padding:14px;border-radius:13px}shipping-notice .zlg-shipping-top{gap:10px}shipping-notice .zlg-shipping-icon{width:36px;height:36px;flex-basis:36px}shipping-notice .zlg-shipping-message{font-size:11px}}
          @media(prefers-reduced-motion:reduce){shipping-notice .zlg-shipping-fill{animation:none}}
        </style>
        <div class="zlg-shipping-card ${shippingSuccess ? 'is-complete' : ''}">
          <div class="zlg-shipping-top">
            <span class="zlg-shipping-icon" aria-hidden="true"><svg viewBox="0 0 24 24">${icon}</svg></span>
            <div class="zlg-shipping-copy">
              <div class="zlg-shipping-region" aria-label="Kostenloser Standardversand innerhalb Deutschlands ab ${thresholdLabel}" style="display:flex;align-items:center;justify-content:center;gap:6px;font-size:10px;line-height:1.4;margin:0 0 3px"><span aria-hidden="true" style="display:inline-block;width:16px;height:11px;flex:0 0 16px;border-radius:2px;background:linear-gradient(to bottom,#151515 0 33.333%,#d11f2a 33.333% 66.666%,#f2c230 66.666% 100%);vertical-align:middle;box-shadow:0 0 0 1px #00000012"></span><span>DE &middot; Versandfrei ab ${thresholdLabel}</span></div>
              <div class="zlg-shipping-message" role="status" aria-live="polite" aria-atomic="true">${shippingMessage}</div>
            </div>
          </div>
          <div class="zlg-shipping-track" role="progressbar" aria-label="Fortschritt zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}">
            <span class="zlg-shipping-fill" style="--ship-progress:${progress}%"></span>
          </div>

        </div>`;
    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}